export default {
      id: "as-ambulant-toilet-usage",
      viewBox: "0 0 56 56",
      url: "/" + "sprite.svg#as-ambulant-toilet",
      toString: function () {
        return this.url;
      }
    }